<template>
	<IconBase icon-name="current">
		<path d="M7,20 16,10" class="grayStroke" />
		<circle cx="16" cy="10" r="3" class="whiteFill blueStroke" />
	</IconBase>
</template>

<script>
import IconBase from './IconBase';
export default {
	components: {
		IconBase
	}
};
</script>
